import React from 'react';
import { CampaignCardsFeedCarouselSkeleton } from './layouts/carousel/FeedCarouselSkeleton';
import { CampaignCardsFeedGridSkeleton } from './layouts/grid/FeedGridSkeleton';
import { CampaignCardsFeedProps } from './campaign-cards-feed-props';
import { CardsFeedLayouts } from './layouts/cards-feed-layout-ids';

export function CampaignCardsFeedSkeleton(arg: {
  props: CampaignCardsFeedProps;
  animated?: boolean;
}) {
  const { animated = true, props } = arg;
  const { feedLayoutId } = props;

  switch (feedLayoutId) {
    case CardsFeedLayouts.CAROUSEL:
      return <CampaignCardsFeedCarouselSkeleton {...arg} animated={animated} />;
    case CardsFeedLayouts.GRID:
    default:
      return <CampaignCardsFeedGridSkeleton {...arg} animated={animated} />;
  }
}
